import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'appHasError',
  standalone: true
})
export class HasErrorPipe implements PipeTransform {
  transform(control: AbstractControl | null, errorType: string): boolean {
    return control ? control.hasError(errorType) : false;
  }
}